module.exports = __webpack_public_path__ + "img/sy.b288d060.svg";